import react from 'react'
import style from './style.module.css'

const Error: React.FC = () => {

    return (
        <>
            <div className={style.error}>
                <div className={style.frame}>
                    <h2>404</h2>
                    <h3>View Not Found</h3>
                </div>
            </div>
        </>
    )
}

export default Error;